module.exports = __webpack_public_path__ + "img/image3.eda0e43b.jpg";